<template>
  <div>
    <div style="text-align:center;">
      <span>查询条件：</span>
      <el-input
        style="width:45%; margin:20px auto;"
        placeholder="请输入关键字"
        v-model="searchText"
        size="mini"
      ></el-input>
      <el-button type="primary" size="mini" @click="listSearch()">查询</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column label="序号" width="50">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.$index+1}}</span>
        </template>
      </el-table-column>
      <el-table-column label="来访单位" align="left">
        <template slot-scope="scope">
           <label v-if="scope.row.reservationType===0" class="label greenlabel">预</label>
           <label v-else class="label">临</label>
            {{scope.row.visitorCompanyName}}
        </template>
      </el-table-column>
      <el-table-column label="来访人" width="70">
        <template slot-scope="scope">
          <slot>{{scope.row.visitorUserName}}</slot>
        </template>
      </el-table-column>
      <el-table-column prop="actualPeopleCount" label="人数" width="50"></el-table-column>
      <el-table-column prop="reservationDate" label="预约时间" width="110"></el-table-column>
      <el-table-column prop="visitorProvinceCode" label="来自区域" width="80"></el-table-column>
      <el-table-column prop="targetUserName" label="受访人" width="70"></el-table-column>
      <el-table-column prop="targetDepartmentName" label="部门" width="100"></el-table-column>
      <el-table-column label="联系方式" width="130">
        <template slot-scope="scope">
          <div>{{scope.row.mobile!=undefined?scope.row.mobile:''}}</div>
          <div>{{scope.row.phone!=undefined?scope.row.phone:''}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="leaveTime" label="离开时间" width="100"></el-table-column>
      <el-table-column label="状态" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.state===1" style="color:blue;">待批准</span>
          <span v-if="scope.row.state===2" style="color:blue;">待访问</span>
          <span v-if="scope.row.state===3" style="color:blue;">待离开</span>
          <span v-if="scope.row.state===4" style="color:blue;">已变更</span>
          <span v-if="scope.row.state===5" style="color:blue;">已取消</span>
          <span v-if="scope.row.state===6" style="color:blue;">已结束</span>
          <span v-if="scope.row.state===7" style="color:blue;">已拒绝</span>
          <span v-if="scope.row.state===10" style="color:blue;">已访问</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="操作" width="80">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="oper(scope.row)"
            size="mini"
            plain
          >{{scope.row.state===6?'查看':'登记'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
 
  </div>
</template>
<script>
import { getToDayGuardReservationList } from "@/api/api";

export default {
  data() {
    return {
      user: {},
      searchText: "",
      tableData: []
    };
  },
  props: {
    rType: 0
  },
  created() {
    window.sessionStorage.activeName=this.rType;
    this.user = JSON.parse(window.localStorage.user);
    this.listSearch();
  },
  //超过8个字符隐藏后面的
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 10) + "...";
      }
      return value;
    }
  },
  methods: {
    oper(row) {
      this.$emit("openCheck",row.id);
    },
    //刷新加载数据
    listSearch() {
      var doorId = "";
      if (this.user.door != undefined) {
        doorId = this.user.door.id;
      }
      var para = {
        params: {
          companyId: this.user.companyId,
          doorId: doorId,
          rType: this.rType,
          searchText: this.searchText
        }
      };
      var _this = this;
      getToDayGuardReservationList(para).then(res => {
        if (res.data.success) {
          _this.tableData = res.data.data;
        } else {
          _this.$message.error(res.data.msg);
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/fksys/fksysTable.vue